<template>
    <div>
        <h1 class="mb-4 font-active">Free Insured Shipping</h1>
        <p>
            At Friendly Diamonds India, we offer Free Insured Shipping for all our orders across India. To make your shopping experience as hassle-free as possible, we also offer Free Return Shipping on all orders from India.
        </p>
        <h3>Shipping Timeline</h3>
        <p>
            At Friendly Diamonds, we're dedicated to delivering your order on time. However, in rare cases, unforeseen circumstances such as inclement weather, carrier delays or inaccurate addresses may affect the delivery period. We do not hold liability for such factors.
            <br><br>
            All our orders are consigned via 2 business-day shipments. All loose diamond orders are typically delivered within 2 to 10 days from the order date. All gold made-to-order items are delivered within 12 from the order date and all platinum made-to-order items are delivered within 14 from the order date. 
        </p>
        <h3>Delivery Partners</h3>
        <p>
            We partner with trusted delivery companies, such as DHL and Blue Dart for all shipments. An alternative shipping method may be used when appropriate to reach your target destination and delivery date.
        </p>
        <h3>Safety Precautions & Insurance</h3>
        <p>
            For your protection, Friendly Diamonds India always insures all items for their total value. You will receive an email confirmation once your order is shipped by us and all shipments will require an adult signature at the delivery destination. 
            <br><br>
            To make sure your order gets delivered to the right hands, the recipient will be requested to provide one of the following government-approved photo identification cards:
        </p>
        <br>
        <ul>
            <li>Aadhar Card / Pan Card</li>
            <li>Voters Identification Card; or</li>
            <li>Passport </li>
        </ul>
    </div>
</template>

<script setup>
   
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color:#606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h3, h2{
        font-size: 18px;
    }

    p{
        font-size: 14px;
    }
}
</style>